<template>
    <el-collapse-item title="管道编辑" name="pipeeditor">
        <div class="pipeeditor-wrap">
           <!--可拖动-->
           <div class="img-type" v-for="(item,index) in nodetype" :key="item.name" data-groupid="pipeditor" :data-groupindex="-1" 
            :data-childindex="index" :title="item.name">
               <img :src=" baseUrl + '/img/simulation/'+item.img+'?_v'+version" data-groupid="pipeditor" :data-groupindex="-1" @dragstart="e=>isDraggable(item,e)" @click="e=>nodeClick(item,e)"
                :data-childindex="index"/>
           </div>
        </div>

        <!--属性设置面板-->
        <el-dialog
            title="提示"
            :visible.sync="pipeattr_dialog"
            v-if="pipeattr_dialog"
            :append-to-body="true"
            :modal="false"
            custom-class="pipeattr_dialog"
            :close-on-click-modal="false"
            v-drag>
            <span slot="title">属性编辑框</span>
            <!--压力温度输入属性---->
            <pressure-attr v-if="(curProperties._type=='pressure'||curProperties._type=='flux'||
                curProperties._type=='input'||curProperties._type=='unknownInput'||
                curProperties._type=='output'||curProperties._type=='unknowOutput')" @close="pipeattr_dialog=false"></pressure-attr>
            <!--节点属性--->
            <branch-attr v-else-if="curProperties._type=='branch'&&simutype=='steam'" @close="pipeattr_dialog=false"></branch-attr>
            <!--阀门属性--->
            <valve-attr v-else-if="curProperties._type=='valve'&&simutype=='water'" @close="pipeattr_dialog=false"></valve-attr>
            <!--连接点属性--->
            <nodes-attr v-else-if="curProperties._type=='branch'&&simutype=='water'" @close="pipeattr_dialog=false"></nodes-attr>
            <!--水池属性--->
            <tank-attr v-else-if="curProperties._type=='tank'&&simutype=='water'" @close="pipeattr_dialog=false"></tank-attr>
            <!--水库属性--->
            <reversior-attr v-else-if="curProperties._type=='reservoir'&&simutype=='water'" @close="pipeattr_dialog=false"></reversior-attr>
            <!--管道属性--->
            <line-attr v-else-if="curProperties._type=='line'&&simutype=='steam'" @close="pipeattr_dialog=false"></line-attr>
            <!--水管道的属性编辑框--->
            <water-attr v-else-if="curProperties._type=='line'&&simutype=='water'" @close="pipeattr_dialog=false"></water-attr>
            <!--保温水管道的属性编辑框--->
            <insulationwater-attr v-else-if="curProperties._type=='line'&&simutype=='insulationWater'" @close="pipeattr_dialog=false"></insulationwater-attr>

            <!--其他未知类型节点的属性--->
            <common-attr v-else @close="pipeattr_dialog=false"></common-attr>


        </el-dialog>
    </el-collapse-item>
</template>

<script>
import { mapState } from 'vuex';

import { Fill, Text,Style,Icon} from 'ol/style';
import {Snap,Select,DragPan,DoubleClickZoom} from 'ol/interaction';

import Feature from 'ol/Feature';
import {Point,LineString} from 'ol/geom';

import Drag from "./Drag"; // 拖动
import LineDraw from "./LineDraw"; // 绘制管道
import NodeTypes from "./Nodes";// 节点类型
import MouserInteraction from "./MouserInteraction"; // 右键菜单


import {pointToFootDist,renderFeature,renderSelectFeature} from '../../utils/mapUtils'

export default {
    name:"pipeeditor",
    computed:{
        ...mapState('simulation',[
            'map',
            'curFeatures', // 当前选中数组
            'lines', // 管线
            'nodes', // 节点
            'simutype', // 仿真介质类型
            "drawSource", // 绘图图层
            "mapMode", // 绘图模式
        ]),
        // 当前选中的独立样式
        curProperties(){
            let pro=this.curFeature?this.curFeature.getProperties():{};
            return pro;
        },
        // 当前选中的Feature
        curFeature(){
            return this.$store.state.simulation.curFeatures[0];
        },
    },
    watch:{
        // 地图模式
        mapMode(newValue){
            // 恢复出厂设置
            this.mapRestore();
            // 如果绘图处于模拟计算模式，则暂停绘图和拖动
            if(newValue=='simulation'){
                // 禁止拖动
                if(this.dragInteration){
                    this.dragInteration.setActive(false);
                }
                // 禁止选中
                if(this.selectInteration){
                    this.selectInteration.setActive(false);
                }
                // 取消选中
                this.$store.commit("simulation/setCurFeatures",[]);
            }else{
                // 启动拖动
                if(this.dragInteration){
                    this.dragInteration.setActive(true);
                }
                // 恢复选中
                if(this.selectInteration){
                    this.selectInteration.setActive(true);
                }
            }
        },
    },
    components:{
        'pressure-attr':()=>import('../PipeAttr/PressureAttr.vue'),// 压力属性编辑框
        'branch-attr':()=>import('../PipeAttr/BranchAttr.vue'),// branch节点属性编辑框
        'line-attr':()=>import('../PipeAttr/LineAttr.vue'), // 蒸汽管道属性编辑框
        'common-attr':()=>import('../PipeAttr/CommonAttr.vue'), // 通用管道属性编辑框

        'water-attr':()=>import('../PipeAttr/WaterAttr.vue'), // 水管道属性编辑框
        'insulationwater-attr':()=>import('../PipeAttr/InsulationWaterAttr.vue'), // 水管道属性编辑框
        'valve-attr':()=>import('../PipeAttr/ValveAttr.vue'), // 阀门属性编辑框
        'tank-attr':()=>import('../PipeAttr/TankAttr.vue'), // 水池属性编辑框
        'reversior-attr':()=>import('../PipeAttr/ReversiorAttr.vue'), // 水库属性编辑框
        'nodes-attr':()=>import('../PipeAttr/NodesAttr.vue'), // 连接点属性编辑框
    },
    data(){
        return {
            baseUrl: this.$store.state.assetsUrl,

            /**
             * (1) _node_type 标志结点类型
             * 主要有三种，0，1，2：
             * 0 代表可以连接多条线段
             * 1 代表只能连接一条线段
             * 2 代表只能在线段上移动
             * 
             * (2) type_：标志绘制图形的类型
             * 主要有：line，branch......
             * 除了line是管线之外，其他都是节点
             */
            nodetype:NodeTypes,

            pipeLayer:null, // 管道图层
            pipeSource:null, // 管道资源

            pipeLines:[], // 管道线数组
            pipeDevices:[], // 管道上的设备

            drawInteration:null, // 绘图方法
            dragInteration:null, // 拖动交互
            dragPanInteration:null, // 拖动地图
            doubleClickInteration:null, // 双击放大地图
            selectInteration:null, // 选中交互事件

            pipeattr_dialog:false, // 属性面板

            version:process.env.VUE_APP_VERSION
        }
    },
    mounted(){
        // 监听组件创建事件
        this.$bus.$on("createPipeNode",this.createPipeNode);
        // 监听地图恢复事件
        this.$bus.$on("mapRestore",this.mapRestore);
        // 监听属性框编辑事件
        this.$bus.$on("editProperies",this.editProperies);

        this.$nextTick(()=>{
            // 执行初始化
            this.init_vector();
        })
    },
    methods:{
        // 初始化地图
        init_vector(){
            let that=this;
            this.pipeSource=that.drawSource;

            // let selectFeature=null;
            // 添加选择
            let select = new Select({
                style:renderSelectFeature
            });
            this.map.addInteraction(select);
            select.on("select",e=>{
                let curFeatures=this.$store.state.simulation.curFeatures;
                // 是否拖动元素
                if(curFeatures.length>0){
                    let selectArr=select.getFeatures();
                    selectArr.clear();
                    // 重新设置选中状态
                    selectArr.extend(curFeatures);
                }
            });
            this.selectInteration=select;

            // 增加自定义的交互，拖动交互
            let drag=new Drag({
                source:this.pipeSource
            });
            this.map.addInteraction(drag);
            drag.on("dragstart",e=>{
                let dragFeature=e.feature;

                // 清除样式
                that.cancelSelect();
                if(dragFeature){
                    // 设置当前选中
                    let selectArr=this.selectInteration.getFeatures();
                    //  如果处在框选状态中
                    if(dragFeature instanceof Array){
                        selectArr.extend(dragFeature);
                        this.$store.commit("simulation/setCurFeatures",dragFeature);
                    }else{ // 单选状态
                        selectArr.push(dragFeature);
                        this.$store.commit("simulation/setCurFeatures",[dragFeature]);
                    }
                }else{
                    // 触发选中
                    this.$store.commit("simulation/setCurFeatures",[]);
                }
            });
            drag.on("dragend",e=>{
                // 记录快照
                this.$store.commit("simulation/recordSnapshot");
            });
            this.dragInteration=drag;
            drag.setActive(false);

            // 增加吸附
            let snap = new Snap({
                source: this.pipeSource,
            });
            this.map.addInteraction(snap);

            // 绘制线段
            let lineDraw=new LineDraw();
            this.map.addInteraction(lineDraw);
            lineDraw.setActive(false);
            this.drawInteration=lineDraw;
            // 绘制完成
            lineDraw.on("drawend",e=>{
                // 恢复出厂设置
                this.mapRestore();
                // 选中绘制的要素
                let feature=e.feature;
                // 取消选中
                this.cancelSelect();
                // 设置当前选中
                let selectArr=this.selectInteration.getFeatures();
                selectArr.push(feature);
                this.$store.commit("simulation/setCurFeatures",[feature]); 

                // 设置id号，编号从1开始
                let id=this.lines.length+1;
                // 遍历全部管线，查找最大id号
                this.lines.forEach(item=>{
                    let tempid=item.get("id");
                    tempid=parseInt(tempid);
                    if(id<=tempid){
                        id=tempid+1;
                    }
                });
                feature.set("id",id);
                feature.set("_type","line"); // 设置类型
                feature.set("_shape","pipe"); // 要素类型

                // 加入图层
                this.drawSource.addFeature(feature);
                this.lines.push(feature); // 增加管道索引

                // 通知其他的组件管道加载完成了,这里暂时可能有问题，待以后再处理
                this.$store.commit("simulation/setLines",this.lines);

                // 记录快照
                this.$store.commit("simulation/recordSnapshot");

            });

            // 获取地图拖动交互事件
            let interactions=this.map.getInteractions();
            interactions.forEach(item=>{
                if(item instanceof DragPan){
                    this.dragPanInteration=item;
                }
                if(item instanceof DoubleClickZoom){
                    this.doubleClickInteration=item;
                }
            });
            // 禁用双击放大
            this.doubleClickInteration.setActive(false);

            // 添加双击 打开属性信息框
            const hitTolerance=10; // 吸附半径
            this.map.on("dblclick",e=>{
                // 遍历双击位置，是否存在相关的图形
                let db_feature=this.map.forEachFeatureAtPixel(e.pixel,feature=>{
                    return feature; // 获取找到的第一个feature
                },{
                    hitTolerance:hitTolerance
                });
                // 如果双击的地方存在feature
                if(db_feature){
                    // 进行选中操作
                    // 触发选中
                    this.$store.commit("simulation/setCurFeatures",[db_feature]);
                    // 设置选中样式
                    let selectArr=select.getFeatures();
                    selectArr.clear();
                    selectArr.push(db_feature);

                    // 显示属性编辑框
                    this.editProperies(db_feature);
                }
            });

            /**
             * 鼠标右键操作
             */
            let mouserInteraction=new MouserInteraction();
            this.map.addInteraction(mouserInteraction);

        },
        // 显示属性编辑框
        editProperies(feature){
             /**
             * 根据需要:在管道上有阀门或者是水泵的时候，管道的属性就不可以编辑了 
             * 那么就需要获取当前节点类型，判断是否为管道，并判断其上是否有阀门或者水泵
             * */
            let props=feature.getProperties();
            let _node_type=props._node_type;
            let dialogFlag=true;
            if(_node_type==10){
                // 因为阀门和水泵都放在了devices属性中
                let devices=props.devices;
                if(devices){
                    for(let d of devices){
                        let deviceProps=d.getProperties();
                        let dtype_=deviceProps._type;
                        if(dtype_=="valve"||dtype_=="pump"){
                            dialogFlag=false;
                        }
                    }
                }
            }
            // 显示属性框
            if(dialogFlag){
                this.pipeattr_dialog=true;
            }
        },
        // 创建节点
        createPipeNode(node){
            // 处于仿真模式不进行节点创建
            if(this.mapMode=="simulation"){   
                return;
            };

            let that=this;
            let nodeProps=this.nodetype[node.childindex];

            // 创建一个Feature
            let _node_type=nodeProps._type;
            let node_tepm_name="common";
            switch(_node_type){
                case "input":
                    node_tepm_name="input";
                    break;
                case "unknownInput":
                    node_tepm_name="unknownInput";
                    break;
                case "unknowOutput":
                case "output":
                    node_tepm_name="output";
                    break;
                default:
                    break;
            }
            let nodes=this.nodes[node_tepm_name];
            if(!nodes){
                nodes=[];
                this.nodes[node_tepm_name]=[];
            }

            // 输入节点以及待求输入节点在绘图时只允许出现一次
            if(nodeProps._type=="unknownInput"||nodeProps._type=="input"){
                if(nodes.length>0){
                    return;
                }
            }
            // input、output、unknownInput和unknownOutput编号从100开始
            let nodeId=nodes.length+1;
            if(nodeProps._type=="unknownInput"||nodeProps._type=="input"||nodeProps._type=="unknowOutput"||nodeProps._type=="output"){
                // 遍历上面几个类型的节点数组，找编号最大值编号，编号从1开始
                let tempid=1;
                // 待求输入节点
                if(this.nodes['unknownInput']){
                    this.nodes['unknownInput'].forEach(item=>{
                        let tid=item.get("id");
                        tid=parseInt(tid);
                        if(tempid<=tid){
                            tempid=tid+1;
                        }
                    });
                }
                // 输入节点
                if(this.nodes['input']){
                    this.nodes['input'].forEach(item=>{
                        let tid=item.get("id");
                        tid=parseInt(tid);
                        if(tempid<=tid){
                            tempid=tid+1;
                        }
                    });
                }
                // 输出节点
                if(this.nodes['output']){
                    this.nodes['output'].forEach(item=>{
                        let tid=item.get("id");
                        tid=parseInt(tid);
                        if(tempid<=tid){
                            tempid=tid+1;
                        }
                    });
                }
                // 要从100开始编号
                if(tempid<=100){
                    tempid+=100;
                }
                nodeId=tempid;
            }else{
                // 遍历通用节点数组，找出最大的编号,编号从1开始
                let tempid=1;
                if(this.nodes['common']){
                    this.nodes['common'].forEach(item=>{
                        let tid=item.get("id");
                        tid=parseInt(tid);
                        if(tempid<=tid){
                            tempid=tid+1;
                        }
                    });
                }
                nodeId=tempid;
            }                

            // 新建Feature的id
            nodeProps.id=nodeId;

            let nodename=nodeProps.name;
            let nodetext=nodename+"_"+nodes.length;
            nodetext=nodetext.toUpperCase();

            // 创建节点的Feature
            let iconFeature = new Feature({
                id:nodeId,
                name:nodetext,
            });
            // 设置id号，为什么要调用setId和set("id"),这是因为如果设置了set("id")，那么getId的时候就找不到id号
            let fid=(new Date()).getTime();
            iconFeature.setId(fid);
            // 节点数组增加
            this.nodes[node_tepm_name].push(iconFeature);
            // 提交节点保存
            this.$store.commit("simulation/setNodes",this.nodes);

            // 像素坐标
            let [xpixel,ypixel]=node.coor;
            // 获取屏幕像素坐标到地理坐标到转换
            let coor=this.map.getCoordinateFromPixel([xpixel,ypixel]);
            // 进行吸附操作
            const hitTolerance=15; // 吸附半径
            let snapFeature=this.map.forEachFeatureAtPixel([xpixel,ypixel], function (feature) {
                // 获取吸附feature的类型,如果当前节点需要吸附到管道上，需要将管道和节点进行关联
                let geometry_=feature.getGeometry();
                if(geometry_ instanceof LineString){
                    let associateFlag=false; // 管道和节点是否需要关联
                    // 判断是否靠近第一个点
                    let first_coor=geometry_.getFirstCoordinate();
                    let first_pixel=that.map.getPixelFromCoordinate(first_coor);
                    if(Math.abs(xpixel-first_pixel[0])<=hitTolerance&&Math.abs(ypixel-first_pixel[1])<=hitTolerance){
                        coor=first_coor;
                        /**
                         * 如果已经绑定了一个点，就不应该继续绑定
                         */
                        let node1=feature.get("node1");
                        if(!node1){
                            // 线段绑定点
                            feature.set("node1",iconFeature.getId());
                            associateFlag=true;
                        }
                    }
                    // 判断是否靠近最后一个点
                    let last_coor=geometry_.getLastCoordinate();
                    let last_pixel=that.map.getPixelFromCoordinate(last_coor);
                    if(Math.abs(xpixel-last_pixel[0])<=hitTolerance&&Math.abs(ypixel-last_pixel[1])<=hitTolerance){
                        coor=last_coor;
                        /**
                         * 如果已经绑定了一个点，就不应该继续绑定
                         */
                        let node2=feature.get("node2");
                        if(!node2){
                            feature.set("node2",iconFeature.getId());
                            associateFlag=true;
                        }

                    }
                    /**
                     * 如果管道和节点需要进行关联
                     */
                    if(associateFlag){
                        // 点绑定线段
                        let lines=iconFeature.get("lines");
                        if(!lines){
                            lines=[];
                        }
                        lines.push(feature.getId());
                        // 点绑定线
                        iconFeature.set("lines",lines);
                        // 根据node的类型，决定是否绑定多个线段
                        if(nodeProps._node_type!=0){
                            return feature; // 返回第一找到的 线段feature
                        }
                    }

                }else{
                    coor=geometry_.getCoordinates();
                }

            },{
                hitTolerance:hitTolerance
            });
            // 如果是设备要素，则只能从线上移动，如果放置的位置没有线段，则不予放置
            if(nodeProps._node_type==2){
                if(!snapFeature){
                    return;
                }else{
                    // 如果停靠的位置不是直线，也不进行放置
                    let geom=snapFeature.getGeometry();
                    if(!(geom instanceof LineString)){
                        return;
                    }                        

                    // 放置的位置应该是在线上，如果不在线上，强行设置为线段
                    let p=this.map.getCoordinateFromPixel([xpixel,ypixel]);
                    let lineGeom=snapFeature.getGeometry();
                    let first=lineGeom.getFirstCoordinate();
                    let last=lineGeom.getLastCoordinate();
                    let r=pointToFootDist(p, first, last);
                    // 设置最新坐标
                    coor=r.point;

                    // 计算比例，方便线段长度改变时重新设置设备的位置，
                    // 使用减号容易出现负值，改成了加号
                    let xRation=(r.point[0]-first[0])/(last[0]-first[0]);
                    let yRation=(r.point[1]-first[1])/(last[1]-first[1]);
                    nodeProps.ration=[xRation,yRation];
                    
                    // 进行设备和线段的绑定
                    let devices=snapFeature.get("devices");
                    if(!devices){
                        devices=[];
                    }
                    devices.push(iconFeature.getId());

                    snapFeature.set("devices",devices);
                    // 一个设备只能绑定一条线，但是为了和其他的节点类似，于是就绑定了一个数组
                    iconFeature.set("lines",[snapFeature.getId()]);
                }
            }
            
            // 设置geom
            iconFeature.setGeometry(new Point(coor));
            // 设置样式
            let text="("+nodeId+")";
            let iconStyle = new Style({
                image: new Icon({
                    src: that.baseUrl+'/img/simulation/'+nodeProps.img+'?_v'+this.version,
                    scale:0.7,
                }),
                text:new Text({
                    font:'15px "Fira Sans", sans-serif',
                    text:text,
                    offsetY:-35,
                    fill:new Fill({
                        color:"red"
                    })
                }),
                zIndex:1000
            });
            iconFeature.setStyle(iconStyle);

            // 保存旋转角度
            iconFeature.set("rotation",0);
            iconFeature.set("_shape","node"); // 要素类型为节点

            // 切换选中元素
            this.cancelSelect();
            // 设置当前选中
            let selectArr=this.selectInteration.getFeatures();
            selectArr.push(iconFeature);
            this.$store.commit("simulation/setCurFeatures",[iconFeature]); 
            // 设置管道的属性
            iconFeature.setProperties(nodeProps);
            // 添加到地图上
            this.pipeSource.addFeature(iconFeature);

            // 记录快照
            this.$store.commit("simulation/recordSnapshot");
        },
        // 取消选中
        cancelSelect(){
            let that=this;
            let select=this.selectInteration;
            let selectArr=select.getFeatures();
            // 清除选中
            selectArr.clear();
            // 遍历选中数组，重新设置样式
            let colls=that.pipeSource.getFeatures();
            colls.forEach(ft=>{
                renderFeature(ft);
            });
        },
        // 节点点击
        nodeClick(item,evt){
            // 开启管道绘制
            if(item._node_type>=10){
                // 处于非仿真模式
                if(this.mapMode=="draw"){
                    // 开启绘制
                    this.drawInteration.setActive(true);
                    this.dragInteration.setActive(false);
                    // 设置鼠标样式
                    let element=this.map.getTargetElement();
                    element.style.cursor="crosshair";
                    
                    // 禁止拖动地图
                    this.dragPanInteration.setActive(false);
                    // 禁止选中
                    this.selectInteration.setActive(false);
                }else{
                    this.drawInteration.setActive(false);
                    this.dragInteration.setActive(false);
                }
                

                return true;
           }else{
                // 恢复出厂设置
                this.mapRestore();
                return false;
           }
        },
        // 元素是否可以拖动
        isDraggable(item,evt){
            if(item._node_type>=10){
                evt.preventDefault();
                return false;
            }
            // 恢复出厂设置
            this.mapRestore();
            return true;
        },
        // 恢复初始化
        mapRestore(){
            // 关闭绘制
            this.drawInteration.setActive(false);
            // 开启拖动
            this.dragInteration.setActive(true);
            // 恢复鼠标样式
            let element=this.map.getTargetElement();
            element.style.cursor="default";
            // 恢复拖动地图
            this.dragPanInteration.setActive(true);
            // 恢复选中
            this.selectInteration.setActive(true);
        },
    }
}
</script>
<style lang="scss">
.pipeeditor-wrap{
    display: flex;
    flex-wrap: wrap;

    .img-type{
        width:40px;
        margin-right: 5px;
        cursor: pointer;
        flex: 1 0 25%;
        padding: 10px;

        img{
            width:100%;
            height: 100%; 
        }
    }
    .img-type:last-child{
        width: 55px;
        height: 55px;
        flex: initial;
    }
    // 如果最后一行不是沾满的需要这个样式
    .img-type:nth-last-child(-n+2){
        flex: initial;
        width: 30%;
    }
}

/** 属性对话框 */
.pipeattr_dialog{
    width: max-content;

    .el-dialog__header{
        padding: 5px 10px 5px 10px;
        color: #fff;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        background: #2c99db;

        .el-dialog__headerbtn{
            top: 5px;
            right: 5px;

            .el-dialog__close{
                color: #fff;
            }
        }

    }
    .el-dialog__body{
        padding:10px;
        width: max-content;
        .attr_dialog{
            min-width: 600px;
        }
    }
}
</style>